export default __webpack_public_path__ + "static/media/Nicolas.269aa742.webp";